export default __webpack_public_path__ + "static/media/returnLeft.f49db6ba.svg";